import { agentPhoto } from "@/mocks/propertyMedia";

export default function ContactPanel() {
  return (
    <div className="bg-stone-50 rounded-lg p-6 border border-gray-100">
      <h5 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-5">Kontakt z doradcą</h5>

      <div className="flex items-center gap-4 mb-5">
        <img
          src={agentPhoto}
          alt="Grzegorz Szczepański"
          className="w-16 h-16 rounded-full object-cover object-top border-2 border-amber-100"
        />
        <div>
          <p className="text-base font-bold text-gray-900">Grzegorz Szczepański</p>
          <p className="text-xs text-amber-700 font-medium mt-0.5">Doradca nieruchomości</p>
        </div>
      </div>

      <div className="space-y-3">
        <a
          href="tel:513915464"
          className="flex items-center gap-3 w-full bg-amber-600 hover:bg-amber-700 text-white rounded-md px-4 py-3 transition-colors cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-phone-line text-lg" />
          </span>
          <span className="text-sm font-semibold whitespace-nowrap">513 915 464</span>
        </a>
        <a
          href="tel:723178962"
          className="flex items-center gap-3 w-full bg-white hover:bg-stone-100 border border-gray-200 text-gray-800 rounded-md px-4 py-3 transition-colors cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-smartphone-line text-amber-600 text-lg" />
          </span>
          <span className="text-sm font-semibold whitespace-nowrap">723 178 962</span>
        </a>
        <a
          href="mailto:biuro@profikredyt.com.pl"
          className="flex items-center gap-3 w-full bg-white hover:bg-stone-100 border border-gray-200 text-gray-800 rounded-md px-4 py-3 transition-colors cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-mail-line text-amber-600 text-lg" />
          </span>
          <span className="text-sm font-medium whitespace-nowrap">biuro@profikredyt.com.pl</span>
        </a>
      </div>

      <p className="text-xs text-gray-400 mt-4 text-center leading-relaxed">
        Numer oferty: <strong className="text-gray-600">10</strong> &nbsp;&middot;&nbsp; Wyłączność
      </p>
    </div>
  );
}
